import { Component, Input } from '@angular/core';
import { VoucherDetails } from '../../model/voucher-details.model';

@Component({
  selector: 'app-voucher-details',
  templateUrl: './voucher-details.component.html',
  styleUrls: ['./voucher-details.component.css']
})
export class VoucherDetailsComponent {

  constructor() { }
  
  @Input() showHistory:boolean = true;
  @Input() voucherDetails:VoucherDetails=null;  
  @Input() message="";

  customizeItem(item) {    
    item.editorOptions = {
      readOnly: true
    };
  }
}
